import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import RecoveryPhraseBackup from './RecoveryPhraseBackup';
import { encryptPrivateKey } from '../utils/e2eeRecovery';
import { signalStore } from '../services/signalStore';
import api from '../services/api';

const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function RecoverySettings() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  //const [privateKey, setPrivateKey] = useState(null);
const [signalState, setSignalState] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
  const loadSignalState = async () => {
    try {
      const identityKey = await signalStore.get('identityKey');
      const registrationId = await signalStore.get('registrationId');
      const signedPreKey = await signalStore.get('signedPreKey');

      if (!identityKey?.privKey) {
        setError(
          'Clé de chiffrement introuvable sur cet appareil.'
        );
        return;
      }

      if (!signedPreKey?.keyPair?.privKey) {
        setError(
          'Signed PreKey introuvable sur cet appareil.'
        );
        return;
      }

      setSignalState({
        identityKey,
        registrationId,
        signedPreKey,
      });
    } catch (err) {
      console.error(
        '❌ Erreur récupération état Signal local :',
        err
      );

      setError(
        'Impossible de récupérer les clés de chiffrement.'
      );
    }
  };

  loadSignalState();
}, []);

  const handleRecoveryPhraseConfirm = async (phrase) => {
    try {
      if (!signalState) {
  throw new Error(
    'État Signal introuvable.'
  );
}

const encryptedData = await encryptPrivateKey(
  signalState,
  phrase
);

      await api.post(
        `${API_URL}/api/e2ee/recovery/setup`,
        encryptedData
      );

      // Retour aux paramètres après succès
      navigate('/Parametres');
    } catch (err) {
      console.error(
        '❌ Erreur sauvegarde récupération :',
        err
      );

      throw err;
    }
  };

  const handleBack = () => {
    navigate('/Parametres');
  };

  return (
    <div className="recovery-settings-page">

      <div className="recovery-settings-header">
        <button
          type="button"
          onClick={handleBack}
          className="recovery-back-button"
        >
          ←
        </button>

        <h1>
          🔐 {t('settings.recoveryTitle')}
        </h1>
      </div>

      {error ? (
        <div className="recovery-error">
          {error}
        </div>
      ) : (
        signalState && (
          <RecoveryPhraseBackup
            onConfirm={handleRecoveryPhraseConfirm}
            onSkip={handleBack}
          />
        )
      )}

    </div>
  );
}